const data = {
    pack: 'BOXER BRIEF',
    style: '6-PACK',
    frequency: '',
    size: '',
    email: ''
  };

  document.addEventListener('DOMContentLoaded', function() {
    const style = document.querySelectorAll('.style__button');
    const pack = document.querySelectorAll('.pack__button');
    const frequency = document.querySelectorAll('.frequency__button');
    const size = document.querySelectorAll('.size__button');
    style.forEach((box) => {
      box.addEventListener('click', function() {
        toggleActiveClass(this, style);
      });
    });
    pack.forEach((box) => {
      box.addEventListener('click', function() {
        toggleActiveClass(this, pack);
      });
    });
    frequency.forEach((box) => {
      box.addEventListener('click', function() {
        toggleActiveClass(this, frequency);
      });
    });
    size.forEach((box) => {
      box.addEventListener('click', function() {
        toggleActiveClass(this, size);
      });
    });
  });

  function toggleActiveClass(clickedElement, container) {
    if (! clickedElement.classList.contains('active')) {
      clickedElement.classList.add('active');
      if(clickedElement.dataset.message){
        document.querySelector('.block__subheader').innerHTML = clickedElement.dataset.message ? clickedElement.dataset.message: '';
      }
      if(clickedElement.dataset.handle){
        const size_button = document.querySelector("#custom-size-guide");
        size_button.setAttribute("data-handle", `${clickedElement.dataset.handle}`);
      }
      const key = clickedElement.dataset.id;
      data[key] = clickedElement.dataset.info;
    }
    container.forEach((box) => {
      if (box !== clickedElement && box.classList.contains('active')) {
        box.classList.remove('active');
      }
    });
  }

  function checkData() {
    const emailInput = document.querySelector('.email-input').value.trim();
    const dangerMenssage = document.querySelector('.fields-danger');
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    data['email'] = emailInput;
    const keysWithEmptyValue = Object.keys(data).filter(key => data[key] === '');
    if (keysWithEmptyValue.length > 0) {
      cleanAlerts();
      dangerMenssage.classList.remove('hidden');
    } else if (! emailPattern.test(emailInput)) {
      cleanAlerts();
      document.querySelector('.email-danger').classList.remove('hidden');
    } else {
      saveDataForm();
    }
  }

  function cleanAlerts() {
    document.querySelector('.fields-danger').classList.add('hidden');
    document.querySelector('.email-danger').classList.add('hidden');
    document.querySelector('.success-danger').classList.add('hidden');
  }

  function saveDataForm() {
    document.querySelector('.email-danger').classList.add('hidden');
    const url = 'https://mbs.mottandbow.com/api/klaviyo-addprofile';

    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    };
    fetch(url, options).then(response => {
      if (!response.ok) {
        throw new Error('Request Failed');
      }
      return response.json();
    }).then(data => {
      console.log('Server response:', data);
      if (data.status == 200) {
        cleanAlerts();
        document.querySelector('.success-danger').classList.remove('hidden');
      }
    }).catch(error => {
      console.error('Error:', error.message);
    });
  }